import { render, staticRenderFns } from "./detailsReceiptRecord.vue?vue&type=template&id=1b2c16c6&scoped=true"
import script from "./detailsReceiptRecord.vue?vue&type=script&lang=js"
export * from "./detailsReceiptRecord.vue?vue&type=script&lang=js"
import style0 from "./detailsReceiptRecord.vue?vue&type=style&index=0&id=1b2c16c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2c16c6",
  null
  
)

export default component.exports